import axios from 'axios'

const state = {
  messages: [],
}

const getters = {
  messages: state => state.messages,
}

const actions = {
  async sendMessage({ commit }, message) {

    commit('addMessage', {
      message: message,
      sender: 'user'
    })

    const response = await actions._post(`ask/?query=${message}`)

    console.log(response)
    commit('addMessage', {
      message: response.answer.message,
      sender: 'bot'
    })
  },
  async _post(uri, params = {}) {
    const token = localStorage.getItem("accessToken");

    const response = await axios.post(process.env.VUE_APP_DOC_API_URL + uri, params, {
      headers: {
        'Accept': 'application/json',
        // If the token exists, add the Authorization header
        ...(token && { 'Authorization': `Bearer ${token}` })
      }
    })

    return response.data;
  },
}

const mutations = {
  addMessage(state, payload) {
    state.messages.push(payload)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
